import { render, staticRenderFns } from "./FiltroVersaoApp.vue?vue&type=template&id=632a5298&"
import script from "./FiltroVersaoApp.vue?vue&type=script&lang=js&"
export * from "./FiltroVersaoApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports